



import Page from '../../components/Page/index.vue'

export default {
  name: 'NotFound',
  components: { Page },
}
